<template>
    <div class="col-12 mt20">
        <!--        <input type="text" class="input" placeholder="Vul hier uw code in">-->
        <form @submit.prevent="validateDiscountCode">
            <input type="text" class="input" id="discount-name" v-model="discountCode"
                   :placeholder="label('shop.cart.discount_code.placeholder')">
            <!--        <button class="button grey mt10 small floatRightI">Inwisselen</button>-->
            <button class="button grey mt10 small floatRightI"
                    v-text=" label('shop.cart.discount_code_add')"></button>
        </form>
        <div class="redColor paragraph small mt10" v-if="showError" v-text="feedbackMessage"></div>
    </div>
</template>

<script>
import translations from "../mixins/translations";

export default {
    name: "DiscountCode",
    mixins: [translations,],
    props: {},
    data() {
        return {
            discountCode: null,
            feedbackMessage: null,
            currentLang: {},
            showError: false,
        }
    },
    mounted() {
        this.currentLang = this.lang;
    },
    methods: {
        validateDiscountCode() {
            this.showError = false;

            let data = {discountCode: this.discountCode};
            return this.$store.dispatch('cart/validateDiscountCode', data)
                .then((response) => {
                    let successData = response.data;

                    if (!successData.valid) {
                        this.feedbackMessage = successData.message;
                        this.showError = true;
                    } else {
                        this.showError = false;
                        this.discountCode = null;
                        this.$emit('done')
                    }
                })
                .catch(error => {
                    this.showError = true;
                });
        },
    },
    computed: {},
}
</script>

<style scoped>

</style>
